import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Switcher } from "@similarweb/ui-components";

export const BacklinksFilterSwitcherStyled = styled(Switcher)`
    display: flex;
    overflow: hidden;

    border: 1px solid ${colorsPalettes.carbon[50]};
    border-radius: 3px;

    span {
        & > span {
            border-right: 1px solid ${colorsPalettes.carbon[50]};
            width: auto;
            height: auto;
            padding: 11px 10px;
            color: ${colorsPalettes.midnight[200]};

            &.selected {
                color: ${colorsPalettes.blue[400]};
            }
        }

        &:nth-last-child(1) > span {
            border-right: none;
        }
    }
`;
